import React, { useEffect } from "react";
import classes from "./WhoWeAre.module.scss";
import "../../App.scss";
import { useTranslation } from "react-i18next";
import arrowRight from '../../media/icons/arrow-right-plain.svg';
import businessAnalysisImage from "../../media/software-implementation/what-we-offer/support.webp";
import developerSkillsImage from "../../media/who-we-are/developer-skills.jpeg";
import crownIcon from "../../media/icons/crown.svg";
import wrenchIcon from "../../media/icons/wrench.svg";
import thumbIcon from "../../media/icons/thumb.svg";
import bulbIcon from "../../media/icons/bulb.svg";
import softwareDevelopmentImage from "../../media/IT-consulting/code.webp";
import implementationAndSupportImage from "../../media/software-development/development.jpeg";
import  { ISectorCard } from "../../components/sectors/Sectors.tsx";
import TechnicalExpertise, {
  ITechnicalExpertiseContentBlock,
} from "./TechnicalExpertise.tsx";
import WhiteBlocksList, {
  ITrustedPartnerBlock,
} from "../../ui/components/white-blocks-list/WhiteBlocksList.tsx";
import FormCard from "../../components/formCard/FormCard.tsx";
import Heading from "../../components/services/heading/Heading.tsx";
import blueBackground from "../../media/about-us/blue-background.svg";
import {Link as ScrollLink} from "react-scroll";
import rightArrowIcon from "../../media/icons/arrowRightBlack.svg";
import {Link} from "react-router";

const WhoWeAre = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sectorCards: ISectorCard[] = [
    {
      image: businessAnalysisImage,
      title: t("whoWeAre.whatWeOffer.blocks.0.title"),
      text: t("whoWeAre.whatWeOffer.blocks.0.text"),
      id: 1,
      link: '/services/erp-software-development-services'
    },
    {
      image: softwareDevelopmentImage,
      title: t("whoWeAre.whatWeOffer.blocks.1.title"),
      text: t("whoWeAre.whatWeOffer.blocks.1.text"),
      id: 2,
      link: '/services/software-development-services'
    },
    {
      image: implementationAndSupportImage,
      title: t("whoWeAre.whatWeOffer.blocks.2.title"),
      text: t("whoWeAre.whatWeOffer.blocks.2.text"),
      id: 3,
      link: '/services/software-implementation-and-support'
    },
  ];

  const projectLifecycle = {
    title: t("whoWeAre.projectLifecycle.title"),
    subtitle: t("whoWeAre.projectLifecycle.subtitle"),
    lists: [
      {
        emoji: "📊",
        title: t("whoWeAre.projectLifecycle.lists.0.title"),
        items: t("whoWeAre.projectLifecycle.lists.0.items", {
          returnObjects: true,
        }),
      },
      {
        emoji: "🛠️",
        title: t("whoWeAre.projectLifecycle.lists.1.title"),
        items: t("whoWeAre.projectLifecycle.lists.1.items", {
          returnObjects: true,
        }),
      },
      {
        emoji: "🤝",
        title: t("whoWeAre.projectLifecycle.lists.2.title"),
        items: t("whoWeAre.projectLifecycle.lists.2.items", {
          returnObjects: true,
        }),
      },
    ],
  };

  const technicalExpertiseContentBlocks: ITechnicalExpertiseContentBlock[] = [
    {
      image: businessAnalysisImage,
      title: t("whoWeAre.technicalExpertise.contentBlock.0.title"),
      list: t("whoWeAre.technicalExpertise.contentBlock.0.list", {returnObjects: true}),
    },
    {
      image: developerSkillsImage,
      title: t("whoWeAre.technicalExpertise.contentBlock.1.title"),
      list: t("whoWeAre.technicalExpertise.contentBlock.1.list", {returnObjects: true}),
    },
  ];

  const trustedPartnerBlocks: ITrustedPartnerBlock[] = [
    { title: t("whoWeAre.trustedPartner.blocks.0"), icon: crownIcon },
    { title: t("whoWeAre.trustedPartner.blocks.1"), icon: wrenchIcon },
    { title: t("whoWeAre.trustedPartner.blocks.2"), icon: thumbIcon },
    { title: t("whoWeAre.trustedPartner.blocks.3"), icon: bulbIcon },
  ];

  const aboutUsBlocks = [
    {
      header: [t("whoWeAre.aboutUs.information.0.header")],
      body: t("whoWeAre.aboutUs.information.0.body")
    },
    {
      header: [t("whoWeAre.aboutUs.information.1.header")],
      body: t("whoWeAre.aboutUs.information.1.body")
    },
  ]

  return (
    <main className={classes["who-we-are"]}>
      <Heading title={t("whoWeAre.info.titleBlue")} description={[t("whoWeAre.info.text")]}/>

      <section className="section--white" id="nav-dark">
        <div className={classes["about-us-container"]} id="about-us">
          <div
              className={`${classes["heading-container"]}`}
          >
            <div className={classes.text}>
              <p>{t("whoWeAre.aboutUs.text")}</p>
              <p>{t("whoWeAre.aboutUs.text2")}</p>
            </div>

            <ScrollLink
                className={classes["connect-button"]}
                smooth={true}
                to="contact"
            >
              {t("buttons.connect")}
              <img alt="" src={arrowRight}/>
            </ScrollLink>
          </div>

          <div className={classes["blocks-container"]}>
            {typeof aboutUsBlocks === "object" &&
                aboutUsBlocks.map((item, index) => {
                  return (
                      <div
                          className={`${classes.block} ${classes[`block--${index + 1}`]}`}
                          key={item.body}
                      >
                        <img
                            className={`${classes["block-background"]} ${classes[`block-background--${index + 1}`]}`}
                            src={require(
                                `../../media/about-us/block-background-${index + 1}.svg`,
                            )}
                            alt="block background"
                        />
                        <div className={classes["block-background--blue-container"]}>
                          <img
                              className={`${classes["block-background--blue"]}  ${classes[`block-background--blue--${index + 1}`]}`}
                              src={blueBackground}
                              alt="block background"
                          />
                        </div>
                        <div className={classes["header-container"]}>
                          {typeof item.header === "object" &&
                              item.header.map((header) => (
                                  <h2 className={classes["block-header"]} key={header}>
                                    {header}
                                  </h2>
                              ))}
                        </div>
                        <div className={classes["block-body"]}>{item.body}</div>
                      </div>
                  );
                })}
          </div>
        </div>
      </section>

      <section className={"section--light-gray"}>
        <div className={classes['sectors']}>
          <div className={classes.header}>
            <h2>{t('whoWeAre.whatWeOffer.title')}</h2>
            <p>{t('whoWeAre.whatWeOffer.subtitle')}</p>
          </div>

          <div className={classes.cards}>{
            sectorCards.map((card) => (
                <Link key={card.link} className={classes.card} to={card.link}>
                  <div className={classes["sector-card__text"]}>
                    <img
                        src={card.image}
                        alt={card.title}
                        className={classes["sector-card__image"]}
                    />
                    <div>
                      <h3 className={classes["sector-card__text--title"]}>{card.title}</h3>
                      <p className={classes["sector-card__text--body"]}>{card.text}</p>
                    </div>
                  </div>
                  <span className={classes["project-link"]}>
                    {t("buttons.learnMore")} <img src={rightArrowIcon} alt="Arrow icon"/>
                  </span>
                </Link>
            ))
          }</div>
        </div>
      </section>

      <section className={'section--white'}>
        <div className={classes.lifecycle}>
          <div className={classes.header}>
            <h2>{t("whoWeAre.projectLifecycle.title")}</h2>
            <p>{t("whoWeAre.projectLifecycle.subtitle")}</p>
          </div>

          <div className={classes.cards}>
            {projectLifecycle.lists.map((list, i) => (
                <div key={i}>
                  <span>{list.emoji}</span>
                  <div className={classes.text}>
                    <h5>{list.title}</h5>
                    <ul>
                      {list.items.map(item => (<li key={item}>{item}</li>))}
                    </ul>
                  </div>
                </div>
            ))}
          </div>
        </div>

        <div className={classes.technical}>
          <TechnicalExpertise
              title={t("whoWeAre.technicalExpertise.title")}
              contentBlocks={technicalExpertiseContentBlocks}
          />
        </div>

      </section>

      <section className={"section--dark-gray"} id="nav-light">
        <WhiteBlocksList
            title={t("whoWeAre.trustedPartner.title")}
            blocks={trustedPartnerBlocks}
        />
      </section>

      <section className="section--white" id="nav-dark">
        <FormCard/>
      </section>
    </main>
  );
};

export default WhoWeAre;
